/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Saved_ArticleInputs */

const en_why_listening_saved_article = /** @type {(inputs: Why_Listening_Saved_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved article`)
};

const es_why_listening_saved_article = /** @type {(inputs: Why_Listening_Saved_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículo guardado`)
};

/**
* | output |
* | --- |
* | "Saved article" |
*
* @param {Why_Listening_Saved_ArticleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_saved_article = /** @type {((inputs?: Why_Listening_Saved_ArticleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Saved_ArticleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_saved_article(inputs)
	return en_why_listening_saved_article(inputs)
});